// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --ds-icon-color-accent: var(--ds-color-grey-10);
    --ds-icon-color-brand: var(--ds-color-neon-0);
    --ds-icon-color-brand-indigo: var(--ds-color-indigo-2);
    --ds-icon-color-default: var(--ds-color-grey-20);
    --ds-icon-color-inverted: var(--ds-color-grey-indigo-90);
    --ds-icon-color-informative: var(--ds-color-informative);
    --ds-icon-color-negative: var(--ds-color-negative);
    --ds-icon-color-positive: var(--ds-color-positive);
    --ds-icon-color-warning: var(--ds-color-alert);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
